module.exports = __webpack_public_path__ + "img/superu2.fe0b3fa7.jpg";